export default "__VITE_ASSET__Dso6UwHB__"